'use strict';

var ConfigurationBudgetTargetTransformerFactory = function ConfigurationBudgetTargetTransformerFactory($rootScope, DataTransformer) {
  function ConfigurationBudgetTargetTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-budget-target-mode';
    this.priority = 1;
  }
  ConfigurationBudgetTargetTransformer.prototype = Object.create(DataTransformer.prototype);
  ConfigurationBudgetTargetTransformer.constructor = ConfigurationBudgetTargetTransformer;
  ConfigurationBudgetTargetTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationBudgetTargetTransformer.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationBudgetTargetTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  ConfigurationBudgetTargetTransformer.prototype.transform = function (data) {
    for (var i = 0, length = data.domain.target.length; i < length; i++) {
      var element = data.domain.target[i];
      element.isNewlyAdded = false;
    }
    $rootScope.$broadcast('configuration-budget-target:loadedSuccessful', data);
    return data.domain.target;
  };
  return ConfigurationBudgetTargetTransformer;
};
ConfigurationBudgetTargetTransformerFactory.$inject = ['$rootScope', 'DataTransformerFactory'];
module.exports = ConfigurationBudgetTargetTransformerFactory;